export class ConsumedQtyRequest{
    storeConsumptionId:number;
    saleOrderId:number;
    itemId:number;
    unitId:number;
}